export default __webpack_public_path__ + "static/media/workers.b6dad2ed.svg";